import React, { useEffect, useState } from "react";
import { collection, getDocs, updateDoc, doc, deleteDoc, onSnapshot, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Modal, Button, Alert, Form } from "react-bootstrap";
import "./SongList.css";

const SongList = ({ refreshTrigger }) => {
  const [songs, setSongs] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editSong, setEditSong] = useState(null);
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });
  const [isListVisible, setIsListVisible] = useState(true); // Controla la visibilidad de la lista

  // Función para obtener canciones en tiempo real desde Firestore
  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "songs"), (snapshot) => {
      const songList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSongs(songList);
    });

    return () => unsubscribe(); // Desuscribirse del listener cuando se desmonta el componente
  }, []);

  const assignTag = async (songId, tag) => {
    try {
      const songRef = doc(db, "songs", songId);
      await updateDoc(songRef, { nfcTag: tag });
      setAlert({ show: true, type: "success", message: "Etiqueta NFC asignada." });
    } catch (error) {
      setAlert({ show: true, type: "danger", message: "Error asignando etiqueta NFC." });
    }
  };

  const deleteSong = async (songId) => {
    try {
      const songRef = doc(db, "songs", songId);
      await deleteDoc(songRef);
      setAlert({ show: true, type: "success", message: "Canción eliminada correctamente." });
    } catch (error) {
      setAlert({ show: true, type: "danger", message: "Error eliminando canción." });
    }
  };

  const handleEdit = (song) => {
    setEditSong(song);
    setShowEditModal(true);
  };

  const saveEdit = async () => {
    try {
      const songRef = doc(db, "songs", editSong.id);
      await updateDoc(songRef, { title: editSong.title, artist: editSong.artist, url: editSong.url });
      setShowEditModal(false);
      setAlert({ show: true, type: "success", message: "Canción actualizada correctamente." });
    } catch (error) {
      setAlert({ show: true, type: "danger", message: "Error actualizando canción." });
    }
  };

  const addNewSong = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const newSong = {
      title: formData.get("title"),
      artist: formData.get("artist"),
      url: formData.get("url"),
    };

    try {
      await addDoc(collection(db, "songs"), newSong);
      setAlert({ show: true, type: "success", message: "Canción agregada correctamente." });
      e.target.reset();
    } catch (error) {
      setAlert({ show: true, type: "danger", message: "Error al agregar canción." });
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="text-center">Agregar Videos de Canciones</h2>
     

      {/* Formulario para agregar una nueva canción */}
      <Form onSubmit={addNewSong} className="mb-4">
        <Form.Group controlId="formTitle" className="mb-2">
          <Form.Label>Título</Form.Label>
          <Form.Control type="text" name="title" placeholder="Ingresa el título" required />
        </Form.Group>

        <Form.Group controlId="formArtist" className="mb-2">
          <Form.Label>Artista</Form.Label>
          <Form.Control type="text" name="artist" placeholder="Ingresa el artista" required />
        </Form.Group>

        <Form.Group controlId="formUrl" className="mb-2">
          <Form.Label>URL</Form.Label>
          <Form.Control type="url" name="url" placeholder="Ingresa la URL" required />
        </Form.Group>

        <Button variant="primary" type="submit">
          Agregar Canción
        </Button>
      </Form>

      {/* Botón para mostrar/ocultar la lista */}
      <div className="text-center my-3">
        <Button
          variant={isListVisible ? "secondary" : "primary"}
          onClick={() => setIsListVisible(!isListVisible)}
        >
          {isListVisible ? "Ocultar Lista" : "Mostrar Lista"}
        </Button>
      </div>

      {alert.show && (
        <Alert
          variant={alert.type}
          onClose={() => setAlert({ ...alert, show: false })}
          dismissible
        >
          {alert.message}
        </Alert>
      )}

      {/* Lista de canciones */}
      {isListVisible && (
        <ul className="list-group">
          {songs.map((song) => (
            <li
              key={song.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{song.title}</strong> - {song.artist}
              </div>
              <div>
                <Button
                  variant="primary"
                  className="me-2"
                  onClick={() => assignTag(song.id, "TAG_ID")}
                >
                  <i className="bi bi-tag-fill"></i>
                </Button>
                <Button
                  variant="warning"
                  className="me-2"
                  onClick={() => handleEdit(song)}
                >
                  <i className="bi bi-pencil-fill"></i>
                </Button>
                <Button variant="danger" onClick={() => deleteSong(song.id)}>
                  <i className="bi bi-trash-fill"></i>
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}

      {/* Modal para Editar Canción */}
      {editSong && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Editar Canción o Álbum</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="mb-3">
                <label htmlFor="editTitle" className="form-label">
                  Título
                </label>
                <input
                  type="text"
                  id="editTitle"
                  className="form-control"
                  value={editSong.title}
                  onChange={(e) => setEditSong({ ...editSong, title: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="editArtist" className="form-label">
                  Artista
                </label>
                <input
                  type="text"
                  id="editArtist"
                  className="form-control"
                  value={editSong.artist}
                  onChange={(e) => setEditSong({ ...editSong, artist: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="editUrl" className="form-label">
                  URL
                </label>
                <input
                  type="text"
                  id="editUrl"
                  className="form-control"
                  value={editSong.url}
                  onChange={(e) => setEditSong({ ...editSong, url: e.target.value })}
                />
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cerrar
            </Button>
            <Button variant="primary" onClick={saveEdit}>
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default SongList;
